<template>
    <v-container fluid class="pa-0 mb-offset">
        <crud 
            title='Cliente Cod.Parlante'
            :entity-title='entityTitle'
            action-icon='widgets'
            model-def='pricelist-product-company_spokencode'
            :sub-filters="subFilters"
            :default-input="{pricelistable_id: id, pricelistable_type: 'company'}"
            action-position='absolute'
            :crud-dialog="true"
            class="mb-4"
        ></crud>
        <crud 
            title='Cliente/Articoli'
            :entity-title='entityTitle'
            action-icon='widgets'
            model-def='pricelist-product-company_product'
            :sub-filters="subFilters"
            :default-input="{pricelistable_id: id, pricelistable_type: 'company'}"
            action-position='absolute'
            :crud-dialog="true"
            class="mb-4"
        ></crud>
        <crud 
            title='Articolo Scaglioni Quantità'
            :entity-title='entityTitle'
            action-icon='widgets'
            model-def='pricelist-product-quantity'
            :sub-filters="subFilters"
            :default-input="{pricelistable_id: id, pricelistable_type: 'company'}"
            action-position='absolute'
            :crud-dialog="true"
            class="mb-4"
        ></crud>
    </v-container>
</template>

<script>
    export default {
        name: 'pricelist-index',
        props: {
            id: Number,
            subFilters: Object,
            entityTitle: String
        },

        data() {
            return {
            }
        },

        created() {
            this.$store.commit('endProgress')
        }
    }
</script>

<style>

</style>